import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CallLogResponse } from '../models/responses/call-log-response';
import { environment } from '../environments/environments';
import {HttpParams} from "@angular/common/http";
import { AiAgentDashboardResponse } from '../models/responses/ai-agent-dashboard-response';

@Injectable({
  providedIn: 'root'
})
export class CallLogService {

  constructor(private httpClient: HttpClient) { }

  fetchAiAgentDashboard(aiAgentId: number, startDate: Date, endDate: Date): Observable<AiAgentDashboardResponse> {
    return this.httpClient.post<AiAgentDashboardResponse>(`${environment.callLogUrl}/fetchAiAgentDashboard`, { aiAgentId, startDate, endDate });
  }

  fetchAllByAiAgent(aiAigentId: number): Observable<CallLogResponse[]> {
    const options =
    { params: new HttpParams().set('aiAgentId', aiAigentId) } ;
    return this.httpClient.get<CallLogResponse[]>(`${environment.callLogUrl}/fetchAllByAiAgent`,options);
  }

  removeById(id: number) {
    return this.httpClient.delete(`${environment.callLogUrl}/remove/${id}`);
  }
}
